import React, { Component } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from '@material-ui/core/styles';

import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Done from '@material-ui/icons/Done';
import Cancel from '@material-ui/icons/Cancel';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import history from '../../common/history';

const ITEM_HEIGHT = 48;

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit * 2,
  },
  absolute: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 3,
  },
});

class MenuTooltip extends Component {
  state = {
    anchorEl: null,
  };

  constructor(props){
    super(props);
    this.validateWBS = this.validateWBS.bind(this);
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => 
  {
    this.setState({ anchorEl: null });
  };

  cancelWBSModify(){
    history.push('/')
  }

  validateWBS()
  {
    this.props.validateWBS();
    this.handleClose();
  }

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { classes } = this.props;
    return (
      <div>
        <Tooltip title="More" aria-label="Add">
          <Fab 
            style={{backgroundColor:"#446cb3", color:"white"}} 
            className={classes.absolute}  
            aria-owns={open ? 'long-menu' : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
            >
            <MoreVertIcon />
          </Fab>
        </Tooltip>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
            },
          }}
        >
          {
            this.props.validate?
            (
              <MenuItem key={"Done"}  onClick={this.validateWBS}>
                <ListItemIcon className={classes.icon}>
                  <Done />
                </ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} inset primary="Validate" />
              </MenuItem>
            ):null
          }
          {
            this.props.close?
            (
             <MenuItem key={"Close"}  onClick={this.cancelWBSModify}>
                  <ListItemIcon className={classes.icon}>
                    <Cancel />
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.primary }} inset primary="Close" />
              </MenuItem>
            ):null
          }
          
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(MenuTooltip);


// WEBPACK FOOTER //
// ./src/features/common/MenuTooltip.js